export default function calculateScore(correctAnswers, totalAnswered){
    if(totalAnswered === null) return "";
    else if(correctAnswers === null && totalAnswered !== null) return "0/" + totalAnswered;
    else return correctAnswers + "/" + totalAnswered;
};